import { defineMessages } from 'react-intl'

export default defineMessages({
  back: {
    defaultMessage: 'Back to Smart Shares',
    description: 'cancel smart share modal | cancel button label',
  },
  cancelButton: {
    defaultMessage: 'Do not Cancel',
    description: 'cancel smart share modal | cancel button label',
  },
  confirmButton: {
    defaultMessage: 'Cancel',
    description: 'cancel smart share modal | confirm button label',
  },
  errorNotFound: {
    defaultMessage: 'Smart Share with {shareId} ID not found',
    description: 'cancel smart share modal | not found share error message',
  },
  modalMessage: {
    defaultMessage: 'Are you sure you want to cancel your Smart Share(s)?',
    description: 'cancel smart share modal | modal title label',
  },
  title: {
    defaultMessage: 'Cancel Smart Share(s)',
    description: 'cancel smart share modal | modal title label',
  },
  tryAgain: {
    defaultMessage: 'Try again',
    description: 'cancel smart share modal | try again button label',
  },
  unknowError: {
    defaultMessage:
      'Something went wrong. You can try again below, or contact Support if the problem persists.',
    description: 'cancel smart share modal | unknown error message',
  },
  noSelected: {
    defaultMessage: 'Something went wrong. No smart shared are selected.',
    description: 'cancel smart share modal | no selected error message',
  },
})
